import { Box, Button, Tooltip } from '@mui/material'
import { useTranslation } from 'react-i18next'

import type { AggregateAvailabilityResponse } from '@/features/bidding/types/aggregateAvailability'
import type { AggregateSuggestedBidResponse } from '@/features/bidding/types/aggregateSuggestedBid'
import type { BidLevelInput } from '@/features/bidding/types/bidLadderInput'
import type { BidLevelInputSymmetrical } from '@/features/bidding/types/bidLadderInputSymmetrical'
import type { CascadeMarketId } from '@/features/bidding/types/market'

import useReviewBidsDisabledState from './useReviewBidsDisabledState'

type ReviewBidsButtonProps = {
  selectedMarket: CascadeMarketId
  levels: BidLevelInput[] | BidLevelInputSymmetrical[]
  aggregateSuggestedBids?: AggregateSuggestedBidResponse | null
  aggregateAvailability?: AggregateAvailabilityResponse | null
  activationGroupsCount: number
  onReviewBids?: () => void
}

function ReviewBidsButton({
  selectedMarket,
  levels,
  aggregateSuggestedBids,
  aggregateAvailability,
  activationGroupsCount,
  onReviewBids,
}: Readonly<ReviewBidsButtonProps>) {
  const { t } = useTranslation()

  const { disabled, tooltipReason } = useReviewBidsDisabledState({
    selectedMarket,
    levels,
    aggregateSuggestedBids,
    aggregateAvailability,
    activationGroupsCount,
  })

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'flex-end',
        px: 2,
        py: 1.5,
        borderTop: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Tooltip title={tooltipReason}>
        <span>
          <Button disabled={disabled} variant="contained" onClick={onReviewBids}>
            {t('bidding.bidding_cascading.review_bids.button')}
          </Button>
        </span>
      </Tooltip>
    </Box>
  )
}

export default ReviewBidsButton
